export default class BlocksTabs {
  constructor() {
    this.sections = document.querySelectorAll(".section-tabs");    
  }

  init() {
    this.sections?.forEach((section) => {
      const btns = section.querySelectorAll(".section-tabs .js-btn-tab");
      const tabs = section.querySelectorAll(".section-tabs .js-tab");    

      btns?.forEach((btn, i) => {
        const target = Array.from(tabs)?.find(t => t.dataset.target === btn.dataset.target);
        if (
          !target
          || !target?.children.length > 0
        ) {
          btn.classList.add("is-disabled");
          return;
        }

        btn.addEventListener("click", (e) => {
          e.preventDefault();

          if (btn.classList.contains("is-active")) {
            return;
          }

          Array.from(btns).find(b => b.classList.contains("is-active"))?.classList.remove("is-active");
          Array.from(tabs)?.find(t => t.classList.contains("is-open"))?.classList.remove("is-open");

          btn.classList.add("is-active");
          Array.from(tabs)?.find(t => t.dataset.target === btn.dataset.target)?.classList.add("is-open");

          ScrollTrigger.refresh();
        });
      });
    });    
  }
}